<template>
  <div class="table offer-info">
    <el-form ref="form" :model="c_data">
      <el-table :data="data" ref="table" border highlight-current-row style="margin-top:15px;">
        <el-table-column v-if="c_canEdit" type="selection"></el-table-column>
        <el-table-column show-overflow-tooltip :label="$t('ssrManage.invitationCode')" width="130">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].supplierCode`">
              <el-input v-model="scope.row.supplierCode" disabled></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip :label="$t('ssrManage.supplierNameShort')" width="200">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].supplierNameShort`">
              <el-input v-model="scope.row.supplierNameShort" disabled></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip :label="$t('ssrManage.dc')" width="100">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].warehouseName`" :rules="requiredRule">
              <el-input v-model="scope.row.warehouseName" :disabled="!c_canEdit"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip :label="$t('ssrManage.dcAddress')">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].warehouseAddress`" :rules="requiredRule">
              <el-input v-model="scope.row.warehouseAddress" :disabled="!c_canEdit"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip :label="$t('ssrManage.nature')" width="120">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].nature`" :rules="requiredRule">
              <ic-select table="TT_SSR" field="LOGISTIC_NATURE" v-model="scope.row.nature" :disabled="!c_canEdit"></ic-select>
            </el-form-item>
          </template>
        </el-table-column>
        <!--            <el-table-column :label="$t('ssrManage.totalPalletNum')" width="120">-->
        <!--                <template slot-scope="scope">-->
        <!--                    <el-form-item :prop="`[${scope.$index}].totalPalletNumber`" :rules="[requireRule,numberRule]">-->
        <!--                        <el-input v-model="scope.row.totalPalletNumber" :disabled="!c_canEdit"></el-input>-->
        <!--                    </el-form-item>-->
        <!--                </template>-->
        <!--            </el-table-column>-->
        <el-table-column show-overflow-tooltip :label="$t('ssrManage.availablePalletNum')" header-align="center">
          <el-table-column :label="$t('ssrManage.temperature_normal')" width="120" :disabled="!c_canEdit">
            <template slot-scope="scope">
              <el-form-item :prop="`[${scope.$index}].roomTemperaturePalletNumber`" :rules="requiredRule">
                <el-input v-model="scope.row.roomTemperaturePalletNumber" :disabled="!c_canEdit"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column :label="$t('ssrManage.temperature_cold')" width="120">
            <template slot-scope="scope">
              <el-form-item :prop="`[${scope.$index}].refrigeratePalletNumber`" :rules="requiredRule">
                <el-input v-model="scope.row.refrigeratePalletNumber" :disabled="!c_canEdit"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column :label="$t('ssrManage.temperature_frozen')" width="120">
            <template slot-scope="scope">
              <el-form-item :prop="`[${scope.$index}].freezePalletNumber`" :rules="requiredRule">
                <el-input v-model="scope.row.freezePalletNumber" :disabled="!c_canEdit"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column show-overflow-tooltip :label="$t('ssrManage.freeCarNumber')" width="120">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].freeCarNumber`" :rules="requiredRule">
              <el-input v-model="scope.row.freeCarNumber" :disabled="!c_canEdit"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip :label="$t('ssrManage.outSourcingCarNumber')" width="120">
          <template slot-scope="scope">
            <el-form-item :prop="`[${scope.$index}].outSourcingCarNumber`" :rules="requiredRule">
              <el-input v-model="scope.row.outSourcingCarNumber" :disabled="!c_canEdit"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
  </div>
</template>
<script>
import router from '../../../router';
import { apiService } from "@/api/ssr-manage/ssr-manage";
import { Message } from "element-ui";
import commonMethods from "@/utils/commonMethods";
import IcSelect from "@/components/common/icSelect";

export default {
  name: 'logistic-info-table',
  extends: commonMethods,
  components: { IcSelect },
  props: {
    data: Array,
    canEdit: Boolean
  },
  computed: {
    requiredRule() {
      return [{ required: true, message: 'Can not be empty!', trigger: 'blur' }];
    },
  },
  data() {
    return {
      requiredRule: [{ required: true, message: 'Can not be empty!', trigger: 'blur' }],
      requireRule: { required: true, message: 'Can not be empty!', trigger: 'blur' },
      numberRule: {
        required: true, validator: (rule, value, callback) => {
          if (isNaN(value) || value < 0) {
            callback('Number error!');
          } else {
            callback();
          }
        }, trigger: 'blur'
      },
      c_canEdit: false,
      c_data: []
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    delSelect() {
      let selectRows = this.$refs.table.selection;
      if (selectRows.length == 0) {
        Message.warning('Please select data!');
      }
      selectRows.forEach(row => {
        this.c_data.splice(this.c_data.findIndex(tmp => tmp == row), 1);
      });
    },
    init() {
      this.c_canEdit = this.canEdit
      this.c_data = this.data
    }
  },
  watch: {
    data(val) {
      this.c_data = this.data;
    },
    canEdit(val) {
      this.c_canEdit = this.canEdit;
    },
    c_data(val) {
      this.$emit("update:data", this.c_data);
    }
  }
}
</script>
<style scoped>
/*.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{*/
/*    margin-bottom: 0;*/
/*}*/
</style>
